import type { StepRegistry } from '../StepRegistry';
import { wait } from './utils';

function resolveCoord(coord: [number, number], infraId: string | undefined, systems: any): [number, number] {
  if (infraId && systems.city) {
    const pos = systems.city.getInfraPosition(infraId);
    if (pos) return pos;
  }
  return coord;
}

export function registerVehicleSteps(registry: StepRegistry): void {
  registry.register('spawn-vehicle', async (step, systems, runner) => {
    const { vehicleId, modelId, origin, destination, label, originInfraId, destinationInfraId } = step.params;
    const resolvedOrigin = resolveCoord(origin, originInfraId, systems);
    const resolvedDest = resolveCoord(destination, destinationInfraId, systems);
    const route = systems.vehicles.fetchRoute(resolvedOrigin, resolvedDest);

    runner.trackVehicle(vehicleId);

    systems.routes.addRoute(vehicleId, route);
    systems.vehicles.spawn(vehicleId, modelId, route, step.duration, { label });

    await wait(500);
  });
}
